export default {
  id: 3,
  logo: require('@/assets/Web api.svg'),
  name: 'web api',
  subtitle: 'Exposer ses données sous forme d\'API web',
  description: {
    details: 'Il devient stratégique aujourd\'hui pour les entreprises d\'<b>exposer leurs données</b>, afin de permettre le développement de nouveaux services centrés autour de cette data. Grâce à cette formation, vous serez en mesure de comprendre, d\'utiliser et de concevoir une <b>API REST</b> en suivant les <b>bonnes pratiques</b>.',
    goals: [
      { id: 1, content: 'Comprendre les enjeux des Web API' },
      { id: 2, content: 'Définir les critères d\'une API REST' },
      { id: 3, content: 'S\'interfacer avec une API REST' },
      { id: 4, content: 'Maîtriser les bonnes pratiques' }
    ],
    needs: [
      {
        id: 1,
        title: 'PUBLIC',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/cto.svg'), name: 'DSI' },
          { id: 2, logo: require('@/assets/training/architech.svg'), name: 'Architecte' },
          { id: 3, logo: require('@/assets/training/dataAnalyst.svg'), name: 'Data Analyst' }
        ]
      },
      {
        id: 2,
        title: 'PÉDAGOGIE',
        items: [
          { id: 1, logo: require('@/assets/training/70percent.png'), name: null }
        ]
      },
      {
        id: 3,
        title: 'PRÉ-REQUIS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/generalKnoledge.svg'), name: 'Culture générale en architecture SI' }
        ]
      },
      {
        id: 4,
        title: 'OUTILS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/tools/postman.svg'), name: 'Postman' },
          { id: 2, logo: require('@/assets/training/tools/fiddler.svg'), name: 'Fiddler' },
          { id: 3, logo: require('@/assets/training/tools/artillery.io.png'), name: 'Artillery.IO' }
        ]
      }
    ],
    time: '2 JOURS',
    price: '300 € HT',
    trainer: 'PATRICE'
  },
  program: [
    {
      id: 1,
      title: 'DÉCOUVERTE DES WEB API',
      items: [
        { id: 1, content: 'L\'avantage du HTTP(S)' },
        { id: 2, content: 'WebServices' },
        { id: 3, content: 'Ajax' }
      ]
    },
    {
      id: 2,
      title: 'LES AVANTAGES D\'UNE WEB API',
      items: [
        { id: 1, content: 'Single Page Application' },
        { id: 2, content: 'Multiple front-end' },
        { id: 3, content: 'Facilement scalable (Stateless)' },
        { id: 4, content: 'Séparation des responsabilités' }
      ]
    },
    {
      id: 3,
      title: 'SÉCURISATION',
      items: [
        { id: 1, content: 'Json Web Token' },
        { id: 2, content: 'Clé d\'API' },
        { id: 3, content: 'Oauth2' }
      ]
    },
    {
      id: 4,
      title: 'REST',
      items: [
        { id: 1, content: 'Verbes HTTP (CRUD)' },
        { id: 2, content: 'URI' }
      ]
    },
    {
      id: 5,
      title: 'LE FORMATAGE',
      items: [
        { id: 1, content: 'JSON vs XML' },
        { id: 2, content: 'GeoJson' },
        { id: 3, content: 'Octet-stream' }
      ]
    }
  ]
}
